import { useEffect, useState } from "react";
import { Activity } from "lucide-react";
import { clearConnectionLog, describeLine, watchConnectionLog } from "../lib/connection-log";
import { Button } from "./ui/button";
import { useTaal } from "@/contexts/TaalContext";

/**
 * What the connection did, with the times on it.
 *
 * A phone has no console. Everything interesting about a connection that dies
 * happens while the screen is off and nobody is holding a laptop next to it,
 * so unless it is on a screen afterwards there is nothing to look at but the
 * symptom. This is that screen.
 *
 * Kinds of event and the gaps between them. No addresses, no content, nothing
 * that would matter if somebody were looking over a shoulder.
 */
export default function ConnectionRecord() {
  const { t } = useTaal();
  const [lines, setLines] = useState([]);

  useEffect(() => watchConnectionLog(setLines), []);

  return (
    <div className="border rounded-lg p-4 space-y-3" data-testid="connection-record">
      <div className="flex items-center justify-between gap-2">
        <h4 className="font-medium text-sm flex items-center gap-2">
          <Activity className="h-3.5 w-3.5" />
          {t("Verbindingslog")}
        </h4>
        {lines.length > 0 && (
          <Button variant="ghost" size="sm" onClick={clearConnectionLog} data-testid="clear-record">
            {t("Wissen")}
          </Button>
        )}
      </div>
      <p className="text-xs text-muted-foreground">
        {t("Wanneer het kanaal openging en sloot, wanneer dit apparaat sliep en wakker werd, en elke poging om de verbinding weer op te pakken. Nieuwste bovenaan.")}
      </p>
      {lines.length === 0 ? (
        <p className="text-xs text-muted-foreground" data-testid="record-empty">
          {t("Nog niets vastgelegd.")}
        </p>
      ) : (
        <div className="space-y-0.5 max-h-64 overflow-y-auto" data-testid="record-lines">
          {lines.map((line, index) => (
            <p
              key={`${line.at}-${index}`}
              className="font-mono text-[11px] text-muted-foreground break-all"
            >
              {describeLine(line)}
            </p>
          ))}
        </div>
      )}
    </div>
  );
}
